const DEFAULT_BG_COLOR = '#ffffff';
/**
 * Build global attributes' styles based on background image, gradient, and simple color.
 */
export const buildGlobalBackground = (globalAttributes) => {
    // default background for standard ad
    if (!globalAttributes) {
        return DEFAULT_BG_COLOR;
    }
    const { backgroundColor = DEFAULT_BG_COLOR, background, backgroundImage, } = globalAttributes;
    // backgroundImage has higher priority than gradient
    const fancyBg = backgroundImage
        ? `url(${backgroundImage}) repeat center / auto 100%`
        : background;
    return fancyBg ? `${fancyBg} ${backgroundColor}` : backgroundColor;
};
